import { mdiEmailOutline } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/shared/logic/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "daily-briefing",
  title: "Morgenübersicht",
  icon: mdiEmailOutline,
  tooltip: "Persönlichen Tagesplan, PDF und Planungsausblick per E-Mail einstellen.",
  routeSegment: "daily-briefing",
  // Same projection as the configuration read admission: settings readers or scheduling members.
  getPages: (context) =>
    context.permissions.allows("core.org_settings", "view") ||
    context.permissions.allows("kehrblatt.scheduling", "view")
      ? [
          {
            id: "daily-briefing",
            title: "Morgenübersicht",
            path: "",
            widthType: "normal",
            testId: "controlAdmin.organizationView.tab.dailyBriefing",
          },
        ]
      : [],
}
